module.exports = __webpack_public_path__ + "img/factura.a714ef6b.svg";